import React , { FC } from "react";

const LoadingError: FC= ()=> {
    return <div>error loading</div>;
}

export default LoadingError;

